import React, { useEffect, useRef } from "react";
import "./ContactForm.css";
import form from "../../constant/form";

export default function ContactForm({
  handleSubmit,
  formStatus,
  setFormStatus,
}) {
  const formRef = useRef(null);

  const onFormSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    for (let [key, val] of formData.entries()) {
      console.log(`${key}: ${val}`);
    }
    const data = Object.fromEntries(formData.entries());
    handleSubmit(data);
  };

  useEffect(() => {
    if (formStatus === form.SUCCESS) {
      formRef.current.reset();
    }
  }, [formStatus]);

  const formButtonText =
    formStatus === form.LOADING ? "Loading..." : "Send Message";

  const shouldDisableButton =
    formStatus === form.LOADING ||
    formStatus === form.SUCCESS ||
    formStatus === form.ERROR;

  return (
    <div>
      <section className="contact-form" id="contact">
        <h2>Get in Touch</h2>
        <form onSubmit={onFormSubmit} ref={formRef}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              placeholder="Enter your name"
              required
              name="name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              placeholder="Enter your phone number"
              pattern="[0-9]*"
              inputMode="numeric"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, "");
              }}
              required
              name="phone"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              placeholder="Enter your email"
              required
              name="email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="course">Course</label>
            <select id="course" required name="course">
              <option value="">Select a course</option>
              <option value="science">Science</option>
              <option value="maths">Maths</option>
              <option value="maths">Computer Fundamentals</option>
              <option value="coding">Block-Based Coding</option>
              <option value="web_development">Web Development</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              rows="4"
              placeholder="Your message..."
              name="message"
              required
            ></textarea>
          </div>
          <button type="submit" disabled={shouldDisableButton}>
            {formButtonText}
          </button>
        </form>
      </section>
    </div>
  );
}
